import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Create a root
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render your application inside the root
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
